import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import HomePage from './pages/HomePage';
import POTDList from './pages/POTDList';
import ProblemPage from './pages/problems/ProblemPage';
import SheetsPage from './pages/SheetsPage';
import LCProblems from './pages/LCProblems';
// 1. Import the newly created Striver Page Component
import StriverChallenge from './pages/sheets/StriverChallenge';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Navbar />

      <main style={{ paddingTop: 10 }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/potd" element={<POTDList />} />
          <Route path="/potd/:slug" element={<ProblemPage />} />
          <Route path="/sheets" element={<SheetsPage />} />
          {/* 2. Wire up the dedicated Striver Challenge Route */}
          <Route path="/sheets/striver-challenge" element={<StriverChallenge />} />
          <Route path="/lc-problems" element={<LCProblems />} />
        </Routes>
      </main>

      <Footer />
      <Analytics />
      <SpeedInsights />
    </BrowserRouter>
  );
}
